
        const video = document.getElementById("myVideo");
 
        // video repeat hoti rahe
        video.loop = true;
 
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
 
                    if (entry.isIntersecting) {
                        // section visible -> play
                        video.play();
                    } else {
                        // section hide -> pause
                        video.pause();
                    }
 
                });
            },
            {
                threshold: 0.5
            }
        );
 
        observer.observe(video);


        // video hover play script start

const wrappers = document.querySelectorAll(".video-wrapper");

wrappers.forEach(function(wrapper){

    const video = wrapper.querySelector(".influencers_video");

    wrapper.addEventListener("mouseenter", function(){
        video.play();
    });

    wrapper.addEventListener("mouseleave", function(){
        video.pause();
        video.currentTime = 0;
    });

});

// video hover play script end
   